/**
 * Zone.js configuration
 * This file is custom based on the guide for zone configutation located here
 * https://angular.io/guide/zone
 */

// This setting will allow raw HttpResponse errors to be handled by our global error handling
// Pull request here https://github.com/angular/angular/pull/35873
(window as any).__zone_symbol__DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION = true;
